// extracted by mini-css-extract-plugin
module.exports = {"root":"cmp-Checkbox__checkbox__root","icon":"cmp-Checkbox__checkbox__icon","input":"cmp-Checkbox__checkbox__input","label":"cmp-Checkbox__checkbox__label"};